import Vue from "vue";
import App from "./App.vue";

import VueRouter from "vue-router";
import VueResource from "vue-resource";

import VueSweetalert2 from "vue-sweetalert2";

Vue.use(VueSweetalert2);

import { BASE_URL_API } from "./config";

Vue.use(VueResource);
Vue.use(VueRouter);

import { routes } from "./routes";

const router = new VueRouter({
  base: "/",
  routes,
  mode: "history"
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("user-token");
  const user_mix = localStorage.getItem("user-mix");

  if (to.path === "/faz-login-mix") {
    Vue.http
    .post(BASE_URL_API + '/auth/login', {
        email: 'ybogisich@douglas.com',
        password: '12345'
    }).then(response => {
        response.json().then(json => {
            window.localStorage.setItem('user-token', json.token);

            window.localStorage.setItem('user-mix', 'y');

            next("/");
        });
    }, response => {
        // error callback
        alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.')
    });
  }

  if (!token) {
      if (!user_mix) {
        if (to.path !== "/login") {
            next("/login");
            return;
          }
      } else {
        Vue.http
        .post(BASE_URL_API + '/auth/login', {
            email: 'ybogisich@douglas.com',
            password: '12345'
        }).then(response => {
            response.json().then(json => {
                window.localStorage.setItem('user-token', json.token);
    
                window.localStorage.setItem('user-mix', 'y');
    
                next("/");
            });
        }, response => {
            // error callback
            alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.')
        });
      }
  } else {
    // if (to.path === "/login") {
      Vue.http
        .get(BASE_URL_API + "/status-token", { params: { token } })
        .then(res => res.json())
        .then(json => {}, json => {
          console.log(json);
          if (json.error === "ok") {
            // next("/");
            // return;
          } else {
            if (user_mix) {
                Vue.http
                .post(BASE_URL_API + '/auth/login', {
                    email: 'ybogisich@douglas.com',
                    password: '12345'
                }).then(response => {
                    response.json().then(json => {
                        window.localStorage.setItem('user-token', json.token);
            
                        window.localStorage.setItem('user-mix', 'y');
            
                        next("/");
                    });
                }, response => {
                    // error callback
                    alert('Ocorreu ao tentar fazer o login. Entre em contato com o suporte.')
                });
            } else {
                next("/login");
            return;
            }
          }
        })
    // }
  }

  next();
});

Vue.directive("resize-image", {
    inserted: function(el, binding, vnode) {
        // alert("ola");
        console.log(el);
        el.getElementsByTagName("img")[0].addEventListener("load", function() {
            var maxWidth = el.clientWidth; // Max width for the image
            var maxHeight = el.clientHeight;    // Max height for the image
            var ratio = 0;  // Used for aspect ratio
            var width = el.getElementsByTagName("img")[0].clientWidth;    // Current image width
            var height = el.getElementsByTagName("img")[0].clientHeight;  // Current image height

            var sizes = {
                maxWidth,
                maxHeight,
                width,
                height
            }

            console.log(sizes);

            // Check if the current width is larger than the max
            if(width > maxWidth){
                ratio = maxWidth / width;   // get ratio for scaling image
                el.getElementsByTagName("img")[0].style.width = maxWidth + "px"; // Set new width
                el.getElementsByTagName("img")[0].style.height = (height * ratio) + "px"; // Scale height based on ratio
                // $("img").css("width", maxWidth); // Set new width
                // $("img").css("height", height * ratio);  // Scale height based on ratio
                height = height * ratio;    // Reset height to match scaled image
                width = width * ratio;    // Reset width to match scaled image
            }

            // Check if current height is larger than max
            if(height > maxHeight){
                ratio = maxHeight / height; // get ratio for scaling image
                el.getElementsByTagName("img")[0].style.height = maxHeight + "px"; // Set new height
                el.getElementsByTagName("img")[0].style.width = (width * ratio) + "px"; // Scale width based on ratio
                // $("img").css("height", maxHeight);   // Set new height
                // $("img").css("width", width * ratio);    // Scale width based on ratio
                width = width * ratio;    // Reset width to match scaled image
                height = height * ratio;    // Reset height to match scaled image
            }
        });
    }
});

new Vue({
  el: "#app",
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js